const normalizeHex = (value) => {
  if (typeof value !== 'string') return null
  const raw = value.trim().toLowerCase()
  if (!raw.startsWith('#')) return null
  if (raw.length === 4) {
    return `#${raw[1]}${raw[1]}${raw[2]}${raw[2]}${raw[3]}${raw[3]}`
  }
  if (raw.length === 7) return raw
  return null
}

export const normalizeStockColor = (value) => normalizeHex(value)

export const normalizeStockSize = (value) => {
  if (typeof value !== 'string') return null
  const trimmed = value.trim()
  return trimmed ? trimmed : null
}

export const buildProductStockSummary = (stockItems) => {
  const byColor = {}
  const bySize = {}
  const byColorSize = {}

  const list = Array.isArray(stockItems) ? stockItems : []
  let total = 0

  for (const item of list) {
    const qty = Number(item?.quantity || 0)
    if (!Number.isFinite(qty) || qty <= 0) continue

    total += qty

    const color = normalizeHex(item?.color)
    const size = normalizeStockSize(item?.size)

    if (color) byColor[color] = (byColor[color] || 0) + qty
    if (size) bySize[size] = (bySize[size] || 0) + qty
    if (color && size) {
      const key = `${color}|${size}`
      byColorSize[key] = (byColorSize[key] || 0) + qty
    }
  }

  return { total, byColor, bySize, byColorSize }
}

export const getStockForSelection = (summary, selection) => {
  const color = normalizeHex(selection?.color)
  const size = normalizeStockSize(selection?.size)

  if (color && size) return summary?.byColorSize?.[`${color}|${size}`] || 0
  if (color) return summary?.byColor?.[color] || 0
  if (size) return summary?.bySize?.[size] || 0
  return Number(summary?.total || 0) || 0
}
